import React from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import compose from 'helpers/compose';
import { ErrorStore, GlobalError } from 'stores/errorStore';
import { useStyles } from './errorSnackbarStyles';

interface Props {
  errorStore: ErrorStore;
  autoHideDuration?: number;
}

const ErrorSnackbar: React.FC<Props> = ({ errorStore, autoHideDuration }) => {
  const { globalErrors, clearGlobalErrors, autoHide } = errorStore;
  const classes = useStyles();
  const { t } = useTranslation();

  const renderError = (ge: GlobalError) => {
    const localizationKey = ge.error;
    let msg = t(localizationKey);

    // if the mesage was not localized (not found in dictionary), display an common message
    if (msg === localizationKey) {
      msg = `${t('globalErrors_generic')} [${localizationKey}]`;
    }

    return (
      <>
        {ge.timestamp} - {msg}
      </>
    );
  };

  const errorList = globalErrors.map((ge, i) => (
    <li className={classes.listItem} key={`${ge.error}:${i}`}>
      {renderError(ge)}
    </li>
  ));

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={globalErrors.length > 0}
      autoHideDuration={autoHide ? autoHideDuration : null}
      onClose={clearGlobalErrors}
      style={{ zIndex: 9510 }}
    >
      <SnackbarContent
        aria-describedby="client-snackbar"
        className={classes.root}
        message={<ul className={classes.list}>{errorList}</ul>}
        action={[
          autoHide ? <Button
            className={classes.button}
            variant="text"
            key={1}
            onClick={() => window.location.reload()}
          >
            {t('general_refresh')}
          </Button> : undefined,
          <IconButton
            key="close"
            className={classes.icon}
            aria-label="close"
            color="inherit"
            onClick={clearGlobalErrors}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
};

export default compose(inject('errorStore'), observer)(ErrorSnackbar);
